import { ReactNode, useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

interface GradientImageCardProps {
  imageSrc: string;
  className?: string;
  containerClassname?: string;
  children?: ReactNode;
  moreInfo?: ReactNode;
  moreInfoButton?: string;
  moreInfoButtonClick?: () => void;
}

export const GradientImageCard = ({
  imageSrc,
  className,
  containerClassname,
  children,
  moreInfo,
  moreInfoButton,
  moreInfoButtonClick,
}: GradientImageCardProps) => {
  const [tBusiness] = useTranslation("business");
  const [showMoreInfo, setShowMoreInfo] = useState<boolean>(false);

  return (
    <div
      onMouseEnter={() => moreInfo && setShowMoreInfo(true)}
      onMouseLeave={() => setShowMoreInfo(false)}
      className={classNames(
        "flex relative flex-col items-center justify-center rounded-3xl overflow-hidden",
        className
      )}
    >
      <img
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={imageSrc}
      />
      <div
        className={classNames(
          "w-full h-full absolute left-0 top-0 bg-gradient-to-b from-black/40 to-black/95 to-65% flex flex-col gap-4 items-center justify-center place-items-center p-8",
          containerClassname
        )}
      >
        {children}
        {moreInfo && (
          <button
            onClick={() => setShowMoreInfo(true)}
            className="bg-transparent w-full flex justify-center items-center text-white gap-2 mt-2"
          >
            <p>{tBusiness("Buttons.LearnMore")}</p>
            <ChevronRightIcon className="h-6 w-6" />
          </button>
        )}
      </div>

      {moreInfo && (
        <div
          className={classNames(
            "w-full flex flex-col gap-2 justify-center items-center transition-all duration-300 ease-in-out absolute bg-gradient-to-b from-stone-950/80 to-black bottom-0 left-0 z-10",
            {
              "h-0 overflow-hidden": !showMoreInfo,
              "h-full": showMoreInfo,
            }
          )}
        >
          {moreInfo}
          {moreInfoButton && moreInfoButtonClick && (
            <button
              onClick={moreInfoButtonClick}
              className="bg-transparent w-full flex justify-center items-center text-white gap-2"
            >
              <p>{moreInfoButton}</p>
              <ChevronRightIcon className="h-6 w-6" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
